module.exports = __webpack_public_path__ + "static/tone-bc8cb96c5133c9b667b53762c6c97507.mp4";